
import "react-perfect-scrollbar/dist/css/styles.css"
import "prismjs/themes/prism-tomorrow.css"
import "./components/@vuexy/rippleButton/RippleButton"

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
export default GoogleReCaptchaProvider
